export enum Placeholders {
  email = "Email",
  password = "Password",
  search = "Search",
  title = "Title",
  content = "Type something ...",
  firstName = "First name",
  lastName = "Last name",
  newPassword = "New password",
  newTag = "New tag",
}
